import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import ModalConfirm from "../../components/ModalConfirm";
import NsScrollableTabs from "../../components/NsScrollableTabs";
import ModalAddAssociatiController from "./components/ModalAddAssociatiController";

export default function ModificaGruppoUtenteView({
                                                     show,
                                                     setShow,
                                                     modalMsg,
                                                     showModalDelAssociato,
                                                     setShowModalDelAssociato,
                                                     relAssociatoSel,
                                                     showModalAddAssociati,
                                                     idGruppo,
                                                     setShowModalAddAssociati,
                                                     keyTab,
                                                     setKey,
                                                     scrollableTabs,
                                                     handleOkEliminaAssosc,
                                                     handleOkAddAssosc,
                                                     bottoniSx,
                                                     bottoniDx,
                                                 }) {

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <ModalConfirm
                show={showModalDelAssociato}
                handleClose={() => setShowModalDelAssociato(false)}
                handleOk={handleOkEliminaAssosc}
                testo={"Sicuro di voler rimuovere dal gruppo l'utente: " + (relAssociatoSel && (relAssociatoSel.cognome + ' ' + relAssociatoSel.nome)) + "?"}/>
            <ModalAddAssociatiController
                show={showModalAddAssociati}
                idGruppo={idGruppo}
                handleClose={() => setShowModalAddAssociati(false)}
                handleOk={handleOkAddAssosc}
            />
            <Card
                icon={'fas fa-users'}
                title={idGruppo ? 'Modifica Gruppo Utente' : 'Inserisci Gruppo Utente'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Fragment>
                    <NsScrollableTabs
                        activeIndex={keyTab}
                        onTabChange={(e) => setKey(e.index)}
                        scrollableTabs={scrollableTabs}
                    />
                </Fragment>
            </Card>
        </Fragment>
    );
}